import * as React from 'react';

import { FullBookingRecord } from '../../_graphql/queryBookingDetails';
import { useInvoicesByBookings } from '../../hooks/useInvoicesByBookings';
import { bookingDocuments } from '../_shared/availableDocuments';
import {
  DownloadDocumentsButton,
  PrintDocumentsButton,
} from '../_shared/FetchDocuments';

export type BookingHeaderActionsProps = {
  booking?: FullBookingRecord;
};

export const BookingHeaderActions = ({
  booking,
}: BookingHeaderActionsProps) => {
  const bookingIds = React.useMemo(
    () => (booking ? [booking.id] : []),
    [booking],
  );

  const invoices = useInvoicesByBookings(bookingIds);
  const invoiceNumbers = React.useMemo(
    () => invoices.map((it) => String(it.documentNumber)),
    [invoices],
  );

  return (
    <div className="@BookingHeaderActions flex gap-2">
      <PrintDocumentsButton
        originKey="booking-header"
        documents={bookingDocuments}
        showLabel={false}
        ids={invoiceNumbers}
        isDisabled={!invoiceNumbers.length}
      />
      <DownloadDocumentsButton
        originKey="booking-header"
        compressedFileName={`booking-invoices-${booking?.id}`}
        documents={bookingDocuments}
        showLabel={false}
        ids={invoiceNumbers}
        isDisabled={!invoiceNumbers.length}
      />
    </div>
  );
};
